namespace Vit {
    @Serenity.Decorators.registerEditor([Serenity.ISetEditValue, Serenity.IGetEditValue, Serenity.IStringValue, Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class CaptchaEditor extends Serenity.TemplatedWidget<any> implements
        Serenity.IGetEditValue,
        Serenity.ISetEditValue,
        Serenity.IStringValue,
        Serenity.IReadOnly {



        div: JQuery;
        captchaInput: JQuery;
        captchaImage: JQuery;
        constructor(div: JQuery) {
            super(div);

            this.div = div
        }

        protected getTemplate() {
            return "<div class='captcha'><input class='input-captcha' id='captchaInput' autocomplete='off'></input><img id='captchaImage' src='/captcha'><button class='btn btn-primary btn-sm pull-right' id='captchaRefreshButton'><i class='fa fa-refresh' aria-hidden='true'></i></button></div>";
        }

        public get value() {
            return this.captchaInput.val();
        }

        public getEditValue(prop: Serenity.PropertyItem, target) {
            target[prop.name] = this.value;
        }
        setEditValue(source: any, property: Serenity.PropertyItem): void {
        }

        get_value(): string {
            return this.value;
        }
        set_value(value: string): void {
        }
        get_readOnly(): boolean {
            return false;
        }
        set_readOnly(value: boolean): void {
        }
        public initialize(): PromiseLike<void> {
            this.captchaInput = this.div.find("#captchaInput");
            this.captchaImage = this.div.find("#captchaImage");
            this.div.find("#captchaInput").keypress((e) => {
                if (e.keyCode === 13)
                    e.preventDefault();
            });
            this.div.find("#captchaRefreshButton").click(() => {
                this.captchaImage.attr("src", "/captcha?" + Math.random() * 50000);
                this.captchaInput.val("");
            });
            return super.initialize();
        }
    }
}